import React, { useEffect } from 'react';
import Breadcrumbs from '../../../widgets/breadcrumbs';
import { useFederalStandards } from '../fvs-provider';
import FvsRequirementsProvider from './requirements-provider';
import RequirementInfo from './components/requirement-info';
import RequirementTabs from './components/requirement-tabs';
import FvsMessages from '../components/fvs-messages';
import RequirementsModalWrapper from './components/requirements-modal';
import useRequirementsParams from './useRequirementsParams';

const Requirements = () => {
  const { year, fedStandardCode, standardItemNumber, showCommentTab } =
    useRequirementsParams();

  const {
    standardItem,
    setFvsContextData,
    standardItems,
    isSILoading,
    removeFvsMessageById,
    selectedYear,
    clearAllMessages,
  } = useFederalStandards();

  // 1. Sync year from URL to provider (triggers option fetching in fvs-provider)
  useEffect(() => {
    if (year && selectedYear !== year) {
      setFvsContextData('SET_SELECTED_YEAR', year);
    }
  }, [year]);

  // 2. Sync selection options to provider (triggers standardItems fetching)
  useEffect(() => {
    if (year && fedStandardCode) {
      setFvsContextData('SET_SELECTED_OPTIONS', {
        year,
        fedStandardCode,
        standardItemNumber: standardItemNumber || '',
        vehicleGroup: '',
        vehicleType: '',
      });
    }
  }, [year, fedStandardCode, standardItemNumber]);

  // 3. Set selected standard item AFTER standardItems have loaded
  useEffect(() => {
    if (standardItemNumber && standardItems?.length > 0 && !isSILoading) {
      setFvsContextData('SET_SELECTED_STANDARD_ITEM', standardItemNumber);
    }
  }, [standardItemNumber, standardItems, isSILoading]);

  // 4. Sync showCommentTab from URL to provider
  useEffect(() => {
    if (showCommentTab) {
      setFvsContextData('SET_SHOW_COMMENT_TAB', showCommentTab);
    }
  }, [showCommentTab]);

  // Clear generated messages on load and before unload
  useEffect(() => {
    clearAllMessages();
    return () => {
      clearAllMessages();
    };
  }, []);

  const breadcrumbsPath = [
    {
      location: `${window.AFP_CONFIG.appURLs?.home}/home`,
      label: 'Home',
    },
    {
      location: `${window.AFP_CONFIG.appURLs.catalog}/public/fvs/vehicle-standards`,
      label: 'Federal Vehicle Standards',
    },
  ];

  return (
    <FvsRequirementsProvider>
      <div>
        <div className="grid-row grid-gap" data-testid="fvs-container">
          <div className="tablet:grid-col">
            <Breadcrumbs
              current={`${standardItem?.standardItemNumber} - ${standardItem?.title} - ${standardItem?.year}`}
              path={breadcrumbsPath}
            />
            <FvsMessages onClose={removeFvsMessageById} />
          </div>
        </div>

        <div className="grid-col">
          <RequirementInfo />
          <RequirementTabs />
        </div>
        {standardItem && !isSILoading && <RequirementsModalWrapper />}
      </div>
    </FvsRequirementsProvider>
  );
};

export default Requirements;
